(function(root,factory){
 const api=factory();
 if(typeof module==='object'&&module.exports)module.exports=api;
 if(root)root.PFGSw1BuilderV3ArtworkArchive=api;
})(typeof window!=='undefined'?window:globalThis,function(){
 'use strict';
const MAX_FILE_BYTES=10*1024*1024;
const cache=new WeakMap();
const crcTable=Uint32Array.from({length:256},(_,value)=>{
 for(let bit=0;bit<8;bit++)value=value&1?0xedb88320^(value>>>1):value>>>1;
 return value>>>0;
});
function crc32(bytes){
 let value=0xffffffff;
 for(const byte of bytes)value=crcTable[(value^byte)&255]^(value>>>8);
 return (value^0xffffffff)>>>0;
}
function safeName(name){
 const basename=String(name||'artwork').split(/[\\/]/).pop();
 let result=basename.replace(/[\u0000-\u001f\u007f<>:"|?*]/g,'_').replace(/[. ]+$/g,'');
 if(!result||result==='.'||result==='..')result='artwork';
 if(/^(con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\.|$)/i.test(result))result='_'+result;
 return result;
}
function dosTimestamp(lastModified){
 const date=new Date(Number.isFinite(lastModified)?lastModified:0);
 if(date.getUTCFullYear()<1980)return {time:0,date:33};
 if(date.getUTCFullYear()>2107)return {time:0xbf7d,date:0xff9f};
 return {time:(date.getUTCHours()<<11)|(date.getUTCMinutes()<<5)|(date.getUTCSeconds()>>1),date:((date.getUTCFullYear()-1980)<<9)|((date.getUTCMonth()+1)<<5)|date.getUTCDate()};
}
async function createArchive(file){
 if(file.size>MAX_FILE_BYTES)throw new RangeError('Original artwork must be 10 MiB or smaller.');
 const name=safeName(file.name),encodedName=new TextEncoder().encode(name);
 if(encodedName.length>65535)throw new RangeError('Artwork filename is too long for a ZIP archive.');
 const bytes=new Uint8Array(await file.arrayBuffer()),checksum=crc32(bytes),stamp=dosTimestamp(file.lastModified);
 const local=new Uint8Array(30+encodedName.length),localView=new DataView(local.buffer);
 localView.setUint32(0,0x04034b50,true);localView.setUint16(4,20,true);
 localView.setUint16(6,0x0800,true); // UTF-8 filename; stored data, without a descriptor.
 localView.setUint16(10,stamp.time,true);localView.setUint16(12,stamp.date,true);
 localView.setUint32(14,checksum,true);localView.setUint32(18,bytes.length,true);localView.setUint32(22,bytes.length,true);
 localView.setUint16(26,encodedName.length,true);local.set(encodedName,30);
 const central=new Uint8Array(46+encodedName.length),centralView=new DataView(central.buffer);
 centralView.setUint32(0,0x02014b50,true);centralView.setUint16(4,20,true);centralView.setUint16(6,20,true);
 centralView.setUint16(8,0x0800,true);centralView.setUint16(12,stamp.time,true);centralView.setUint16(14,stamp.date,true);
 centralView.setUint32(16,checksum,true);centralView.setUint32(20,bytes.length,true);centralView.setUint32(24,bytes.length,true);
 centralView.setUint16(28,encodedName.length,true);central.set(encodedName,46);
 const end=new Uint8Array(22),endView=new DataView(end.buffer);
 endView.setUint32(0,0x06054b50,true);endView.setUint16(8,1,true);endView.setUint16(10,1,true);
 endView.setUint32(12,central.length,true);endView.setUint32(16,local.length+bytes.length,true);
 // Keep the untouched byte array. Do not decode, draw, or re-encode the image.
 return new File([local,bytes,central,end],name+'.zip',{type:'application/zip',lastModified:file.lastModified});
}
async function archiveOriginalArtwork(file){
 if(!(file instanceof File))throw new TypeError('Original artwork must be a File.');
 if(!cache.has(file))cache.set(file,createArchive(file).catch(error=>{cache.delete(file);throw error;}));
 return cache.get(file);
}

 return Object.freeze({archiveOriginalArtwork});
});
